export default __webpack_public_path__ + "static/media/powerbutton1.2fd32380.svg";